// extracted by mini-css-extract-plugin
export default {"container":"dUkg1","show":"_77cnk","hide":"LjgRi","desktopContainer":"DfwaW","header":"_2zAmt","backButton":"_6r-DY"};